/**
 * Utility functions for slug-scoped localStorage to prevent cross-tab data pollution
 */

/**
 * Gets a slug-scoped localStorage key
 */
export const getSlugScopedKey = (key: string, slug?: string): string => {
  return slug ? `${key}_${slug}` : key;
};

/**
 * Sets a slug-scoped localStorage item
 */
export const setSlugScopedItem = (key: string, value: string, slug?: string): void => {
  if (typeof window === 'undefined') return;
  const scopedKey = getSlugScopedKey(key, slug);
  localStorage.setItem(scopedKey, value);
};

/**
 * Gets a slug-scoped localStorage item
 */
export const getSlugScopedItem = (key: string, slug?: string): string | null => {
  if (typeof window === 'undefined') return null;
  const scopedKey = getSlugScopedKey(key, slug);
  return localStorage.getItem(scopedKey);
};

/**
 * Removes a slug-scoped localStorage item
 */
export const removeSlugScopedItem = (key: string, slug?: string): void => {
  if (typeof window === 'undefined') return;
  const scopedKey = getSlugScopedKey(key, slug);
  localStorage.removeItem(scopedKey);
};

/**
 * Validates that an operation is targeting the correct account for the current slug
 */
export const validateSlugAccount = (currentSlug: string | undefined, accountSubdomain: string | undefined): boolean => {
  // If no slug in URL, we're in legacy subdomain mode - allow operation
  if (!currentSlug) {
    return true;
  }
  
  // If no account data loaded yet, block the operation
  if (!accountSubdomain) {
    console.warn(`Operation blocked: No account data loaded for slug ${currentSlug}`);
    return false;
  }
  
  // Check if the account matches the current slug
  if (accountSubdomain !== currentSlug) {
    console.error(`Operation blocked: Account mismatch. Current slug: ${currentSlug}, Account subdomain: ${accountSubdomain}`);
    return false;
  }
  
  return true;
}; 

export const validateSlugAccountWithSubdomain = (currentSlug: string | undefined, accountShortcode: string | undefined, accountSubdomain: string | undefined): boolean => {
  // If no slug in URL, we're in legacy subdomain mode - allow operation
  if (!currentSlug) {
    return true;
  }
  
  // If no account data loaded yet, block the operation
  if (!accountShortcode) {
    console.warn(`Operation blocked: No account data loaded for slug ${currentSlug}`);
    return false;
  }
  
  // Check if the account matches the current slug
  if (accountShortcode !== currentSlug && currentSlug !== accountSubdomain) {
    console.error(`Operation blocked: Account mismatch. Current slug: ${currentSlug}, Account subdomain: ${accountSubdomain}`);
    return false;
  }
  
  return true;
}; 